export enum ObjectType {
  PERSON = 'PERSON',
}
